import { useRef } from 'react';

import { CLICK_DELAY_MS } from './constants';
import type { MapMouseEvent, Props } from './types';

const useClick = ({ onClick, onDoubleClick }: Props) => {
    const clickTimeoutRef = useRef<NodeJS.Timeout>(undefined);

    const handleClick = (event: MapMouseEvent) => {
        if (clickTimeoutRef.current) {
            onDoubleClick?.(event);

            return;
        }

        onClick?.(event);

        clickTimeoutRef.current = setTimeout(() => {
            clickTimeoutRef.current = undefined;
        }, CLICK_DELAY_MS);
    };

    return {
        handleClick
    };
};

export default useClick;
